import { render, staticRenderFns } from "./Module30Item.vue?vue&type=template&id=3889bb5d&scoped=true&"
import script from "./Module30Item.vue?vue&type=script&lang=js&"
export * from "./Module30Item.vue?vue&type=script&lang=js&"
import style0 from "./Module30Item.vue?vue&type=style&index=0&id=3889bb5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3889bb5d",
  null
  
)

export default component.exports